export default __webpack_public_path__ + "static/media/(5).4bb2009f.jpeg";